import {
  Component,
  ViewChild,
  Input,
  OnChanges,
  OnInit,
  AfterViewInit,
  OnDestroy,
  SimpleChanges,
  ChangeDetectionStrategy,
  Output,
  EventEmitter
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { MatSelect } from '@angular/material/select';
import { _getOptionScrollPosition } from '@angular/material/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'np-mat-select-hybrid',
  templateUrl: './mat-select-hybrid.component.html',
  styleUrls: ['./mat-select-hybrid.component.scss']
})
export class MatSelectHybridComponent implements OnChanges, OnInit, AfterViewInit, OnDestroy {

  @ViewChild('matSelect') matSelect: MatSelect;
  @Input() selectControl: FormControl;
  @Input() isMultiple?: boolean;
  @Input() label?: string;
  @Input() dataKey: string;
  @Input() dataDisplayValue: string;
  @Input() data: Array<any>;
  @Input() hasNone?: boolean;
  @Input() noneLabel = 'None';
  @Input() hasAll?: boolean;
  @Input() class: string;
  @Input() checkSelectionChange = false;
  @Input() disabled = false;

  @Output() selectionChanged: EventEmitter<any> = new EventEmitter();
  _onDestroy: Subject<void>;

  filterControl: FormControl;
  filteredData: Array<any>;

  constructor() {
    this._onDestroy = new Subject<void>();
    this.filterControl = new FormControl();
    this.filteredData = new Array<any>();
   }

   ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.data && changes.data.currentValue) {
      if (changes.data.currentValue.length) {
        this.filteredData = changes.data.currentValue.slice();
      } else {
        this.filteredData = [];
      }
    }
  }

  ngOnInit() {
    this.filterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterOptions();
      });
  }

  ngAfterViewInit() {
    (<any>this.matSelect)._getItemCount = () => {
      return (
        (<any>this.matSelect).options.length +
        (this.isMultiple && this.data && this.data.length ? 1 : 0)
      );
    };

    (<any>this.matSelect)._scrollActiveOptionIntoView = () => {
      const matSelect = <any>this.matSelect;
      const activeOptionIndex = matSelect._keyManager.activeItemIndex || 0;

      this.matSelect.panel.nativeElement.scrollTop = _getOptionScrollPosition(
        activeOptionIndex +
          (this.isMultiple && this.data && this.data.length ? 1 : 0),
        matSelect._getItemHeight(),
        matSelect.panel.nativeElement.scrollTop,
        matSelect.SELECT_PANEL_MAX_HEIGHT
      );
    };
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  filterOptions() {
    if (!this.data) {
      return;
    }
    // get the search keyword
    let search = this.filterControl.value;
    if (!search) {
      this.filteredData = this.data.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the options
    this.filteredData = this.data
      .filter(
        option =>
          option[this.dataDisplayValue].toLowerCase().indexOf(search) > -1
      )
      .slice();
  }

  selectionchange($event) {
    this.selectionChanged.emit($event);
  }
}
